import { React } from "react";
import { makeStyles } from "@mui/styles";
import {
  Card,
  Grid,
  Input,
  TableContainer,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/DoneAll";
import RevertIcon from "@mui/icons-material/HighlightOff";
import AddNew from "@mui/icons-material/AddCircleOutline";
import { Box } from "@mui/system";

const DataType = {
  String: 0,
  Numeric: 1,
};

const CustomTableCell = ({
  rowIndex,
  row,
  name,
  onChange,
  isEditableField,
  dataType,
}) => {
  const useStyles = makeStyles((themes) => ({
    input: {
      width: 100,
      height: 30,
    },
  }));
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell align="left" className={classes.tableCell}>
      {isEditMode && isEditableField ? (
        <Input
          value={row[name] || ""}
          name={name}
          onChange={(e) => onChange(rowIndex, name, e.target.value, dataType)}
          className={classes.input}
          type={`${dataType == DataType.Numeric ? "number" : "text"}`}
          step={dataType == DataType.Numeric ? "0.01" : ""}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};

export default function PlayerCareerStatsAdvStats(props) {
  const {
    styles,
    data,
    onChange,
    canUpdateData,
    isEditOn,
    RevertEntireRow,
    saveStats,
    addNewRow,
  } = props;
  const StatsTypeAdv = 1;
  const useStyles = makeStyles((themes) => ({
    ...styles,
    table: {
      minWidth: 650,
    },
    selectTableCell: {
      width: 60,
    },
    tableCell: {
      width: 130,
      height: 40,
    },
    input: {
      width: 130,
      height: 40,
    },
    drgContainer: {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "10px",
        height: "10px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#bdbdbd",
      },
      "&::-webkit-scrollbar-thumb": {
        boxShadow: "inset 0 0 8px rgba(0, 0, 0, 0.7)",
      },
    },
    tbl: {
      "& thead tr th": {
        fontSize: "0.75rem",
      },
      "& tbody tr td": {
        fontSize: "0.75rem",
      },
      "& tbody tr:hover td:not([rowSpan])": {
        backgroundColor: "#d5e2fb",
        fontWeight: "bold",
      },
    },
    gridContainer: {
      // width: "calc(100vw - 259px)",
      overflow: "auto",
    },
  }));
  const classes = useStyles();
  return (
    <Paper sx={{ marginTop: "10px", overflow: "auto" }}>
      <Grid container>
        <Grid
          item
          lg={10}
          md={10}
          sm={10}
          xs={10}
          className={classes.sectionTitlePadding}
        >
          <Typography
            noWrap
            variant={styles.gridSectionTitle.variant}
            className={classes.gridSectionTitle}
          >
            Career Advance Stats
          </Typography>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.sectionTitlePadding}
        >
          <Box className={classes.gridContainer}>
            <TableContainer
            // className={classes.drgContainer}
            >
              <Table
                className={`${classes.table} ${classes.tbl}`}
                aria-label="caption table"
              >
                <TableHead>
                  <TableRow>
                    {canUpdateData && (
                      <TableCell align="left">
                        <Tooltip title="Add New Recrod">
                          <IconButton
                            onClick={() => addNewRow()}
                            disabled={isEditOn}
                          >
                            <AddNew />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    )}
                    <TableCell>Season Year</TableCell>
                    <TableCell>TS% </TableCell>
                    <TableCell>eFG%</TableCell>
                    <TableCell>3PA</TableCell>
                    <TableCell>FTr </TableCell>
                    <TableCell>ORB%</TableCell>
                    <TableCell>DRB%</TableCell>
                    <TableCell>TRB%</TableCell>
                    <TableCell>AST%</TableCell>
                    <TableCell>STL%</TableCell>
                    <TableCell>BLK%</TableCell>
                    <TableCell>TOV%</TableCell>
                    <TableCell>USG%</TableCell>
                    <TableCell>ORtg </TableCell>
                    <TableCell>DRtg </TableCell>
                  </TableRow>
                </TableHead>
                {data != null && data.length > 0 && (
                  <TableBody>
                    {data.map((obj, index) => (
                      <TableRow
                        key={`tblAdvStats_${index}`}
                        //title={`${obj.isSeasonEditable ? "Data created by Admin" : obj.isUpdated ? "Sports Radar data updated by Admin" : ""}`}
                        //style={{borderLeft: `5px solid ${obj.isSeasonEditable ? "#228b22" : obj.isUpdated ? "#ff7f50" : "transparent"}`}}
                      >
                        {canUpdateData && (
                          <TableCell align="left">
                            {obj.isEditMode ? (
                              <Box display="flex" flexDirection="row">
                                <Tooltip title="Save">
                                  <IconButton
                                    aria-label="done"
                                    onClick={() => saveStats(index)}
                                    color="success"
                                    sx={{ fontSize: 30 }}
                                  >
                                    <DoneIcon sx={{ fontSize: 20 }} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Cancel">
                                  <IconButton
                                    aria-label="revert"
                                    onClick={() => RevertEntireRow(index)}
                                    color="secondary"
                                  >
                                    <RevertIcon sx={{ fontSize: 20 }} />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            ) : (
                              <Tooltip title="Edit">
                                <IconButton
                                  onClick={() =>
                                    props.SetEditMode(StatsTypeAdv, index)
                                  }
                                  disabled={isEditOn}
                                >
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                        )}
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "seasonYear",
                            onChange,
                            isEditableField: obj.isSeasonEditable,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "tS_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "eFG_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "threePAr",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "fTr",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "orB_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "drB_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "trB_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "asT_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "stL_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "blK_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "toV_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "usG_Pct",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "oRtg",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                        <CustomTableCell
                          {...{
                            rowIndex: index,
                            row: obj,
                            name: "dRtg",
                            onChange,
                            isEditableField: true,
                            dataType: DataType.Numeric,
                          }}
                        />
                      </TableRow>
                    ))}
                  </TableBody>
                )}
                {data != null && data.length == 0 && (
                  <TableBody>
                    <TableRow key={`tblBasicStats_${0}`}>
                      {canUpdateData && <TableCell></TableCell>}
                      <TableCell colSpan="15">
                        <Typography variant="subtitle2" color="secondary">
                          No data found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
